import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { statusList } from "utilities/utility.service";
import { ErrorToastConfig } from "utils/ToastConstants";
import { SuccessToastConfig } from "utils/ToastConstants";
import { add, getSingle, update } from "../announcements.service";
import { getAll as moduleList } from "../../Modules/modules.service";
import { InputTextarea } from "primereact/inputtextarea";
import { getUsersByRole } from "pages/Users/users.service";

const initialVales = {
    id: "",
    role_type: "",
    user_id: "",
    description: "",
    status: "",
};

const AddAnnouncement = () => {
    const { id } = useParams();
    const [values, setValues] = useState(initialVales);
    const [isLoading, setIsLoading] = useState(false);
    const [modules, setModules] = useState([]);
    const [users, setUsers] = useState([]);
    const toast = useRef();
    const history = useHistory();
    const showSuccess = (message) => {
        toast.current.show(SuccessToastConfig(message));
    };
    const showError = (message) => {
        toast.current.show(ErrorToastConfig(message ? message : "Error"));
    };

    useEffect(() => {
        const fetchCurrentRecord = async () => {
            setIsLoading(true);
            const record = await getSingle(id);
            setValues(record);
            setIsLoading(false);
        };

        const fetchModules = async () => {
            setIsLoading(true);
            const list = await moduleList(id);
            setModules(list);
            setIsLoading(false);
        };
        if (id) {
            fetchCurrentRecord();
        }
        fetchModules();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (id) {
            setIsLoading(true);
            const updatedRecord = await update(id, values);
            setValues(updatedRecord);
            if (updatedRecord.status === false) {
                setIsLoading(false);
                showError(updatedRecord?.message);
            } else {
                setIsLoading(false);
                showSuccess("Record updated succssfully");
                history.push("/announcements");
            }
        } else {
            setIsLoading(true);
            const addedRecord = await add(values);
            if (addedRecord.status === false) {
                setIsLoading(false);
                showError(addedRecord?.message);
            } else {
                setIsLoading(false);
                showSuccess("Record added succssfully");
                history.push("/announcements");
            }
        }
    };

    const fetchUsers = async (role_id) => {
        setIsLoading(true);
        const records = await getUsersByRole({ role_id: role_id });
        let usersList = [{ name: "All", id: "All" }];
        if (records) {
            records.forEach((record) => {
                usersList.push({ name: `${record.firstName} ${record.lastName}`, id: record.id+"" });
            });
        }
        setUsers(usersList);
        setIsLoading(false);
    };

    const handleInputChange = async (e) => {
        const { name, value } = e.target;
        if (name === "role_type") {
            if (value === "Processor") {
                fetchUsers(4);
            }
            if (value === "Reporter") {
                fetchUsers(3);
            }
        }
        setValues({
            ...values,
            [name]: value,
        });
    };

    const statuses = statusList();
    const { description, status, role_type, user_id } = values;
    return (
        <Fragment>
            {isLoading && (
                <div className="spinner inner-spinner">
                    <ProgressSpinner />
                </div>
            )}
            <Toast ref={toast} className="ToastMessage" />
            <div className="mb-4">
                <Link to="/announcements">
                    <Button label="Back" className="p-button-sm p-button-success" />
                </Link>
            </div>
            <form method="POST" onSubmit={handleSubmit} autoComplete="Off">
                <div className="grid">
                    <div className="col-12 md:col-6">
                        <div className="card p-fluid">
                            <h5>{id ? "Edit Announcement" : "Add Announcement"}</h5>
                            <div className="field">
                                <label htmlFor="status">Select Role Type*</label>
                                <Dropdown id="role_type" name="role_type" options={["Processor", "Reporter"]} placeholder="Select Role Type" required={true} onChange={(e) => handleInputChange(e)} value={role_type}></Dropdown>
                            </div>
                            <div className="field">
                                <label htmlFor="status">Select User*</label>
                                <Dropdown id="user_id" name="user_id" options={users} filter optionLabel="name" optionValue="id" placeholder="Select User" required={true} onChange={(e) => handleInputChange(e)} value={user_id}></Dropdown>
                            </div>
                            <div className="field">
                                <label htmlFor="name">Description*</label>
                                <InputTextarea id="description" name="description" type="text" required={true} onChange={(e) => handleInputChange(e)} placeholder="Description" value={description} />
                            </div>{" "}
                            <div className="field">
                                <label htmlFor="status">Status*</label>
                                <Dropdown id="status" name="status" options={statuses} optionLabel="status" optionValue="status" placeholder="Select Status" required={true} onChange={(e) => handleInputChange(e)} value={status}></Dropdown>
                            </div>
                            <div>
                                <Button label="Save" type="submit" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Fragment>
    );
};

export default AddAnnouncement;
